import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserListComponent } from './user-list/user-list.component';
import { RouterModule } from '@angular/router';
import { EditUserModalComponent } from './edit-user-modal/edit-user-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClarityModule } from '@clr/angular';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ClarityModule,
    ReactiveFormsModule
  ],
  declarations: [
    UserListComponent,
    EditUserModalComponent
  ],
  entryComponents: [
    EditUserModalComponent
  ],
  exports: [
    UserListComponent,
    EditUserModalComponent
  ]
})
export class UsersSharedModule {
}



// WEBPACK FOOTER //
// ./src/app/users/shared/users-shared.module.ts